import { IGlobalConfig } from "../appRoutesConfig";
import { pageRoutes } from "../routes";
import React from "react";

const authRoutesConfig: IGlobalConfig = [
  {
    auth: [],
    component: React.lazy(() => import("./register")),
    title: "Psychology Reservation | register",
    path: pageRoutes.REGISTER,
    layout: React.lazy(() => import("./layout")),
  },
  {
    auth: [],
    component: React.lazy(() => import("./signup")),
    title: "Psychology Reservation | signup",
    path: pageRoutes.SIGNUP,
    layout: React.lazy(() => import("./layout")),
  },
  {
    auth: [],
    component: React.lazy(() => import("./login")),
    title: "Psychology Reservation | Login",
    path: pageRoutes.LOGIN,
    layout: React.lazy(() => import("./layout")),
  },
  {
    auth: [],
    component: React.lazy(() => import("./loginOtp")),
    title: "Psychology Reservation | Login With Mobile Number",
    path: pageRoutes.LOGIN_OTP,
    layout: React.lazy(() => import("./layout")),
  },
  {
    auth: [],
    component: React.lazy(() => import("./forgotPass")),
    title: "Psychology Reservation | Forgot Password",
    path: pageRoutes.FORGET_PASSWORD,
    layout: React.lazy(() => import("./layout")),
  },
];

export { authRoutesConfig };
